"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCSVParser = exports.ErrorTypes = void 0;
const react_1 = require("react");
const papaparse_1 = __importDefault(require("papaparse"));
const ramda_1 = require("ramda");
var ErrorTypes;
(function (ErrorTypes) {
    ErrorTypes["Quotes"] = "Quotes";
    ErrorTypes["Delimiter"] = "Delimiter";
    ErrorTypes["FieldMismatch"] = "FieldMismatch";
    ErrorTypes["DuplicatedKeyField"] = "DuplicatedKeyField";
    ErrorTypes["EmptyKeyField"] = "EmptyKeyField";
    ErrorTypes["EmptyField"] = "EmptyField";
    ErrorTypes["ParseArray"] = "ParseArray";
    ErrorTypes["Parse"] = "Parse";
})(ErrorTypes || (exports.ErrorTypes = ErrorTypes = {}));
const getEmptyError = (row) => ((0, ramda_1.isEmpty)(row) ? ErrorTypes.EmptyField : null);
const getKeyFieldError = (row, columnIdIndex, uniqueKeys) => {
    const firstColumnKey = Object.keys(row)[columnIdIndex];
    const firstColumnValue = row[firstColumnKey];
    if (!firstColumnValue) {
        return ErrorTypes.EmptyKeyField;
    }
    if (!uniqueKeys.has(firstColumnValue)) {
        uniqueKeys.add(firstColumnValue);
        return null;
    }
    return ErrorTypes.DuplicatedKeyField;
};
const useCSVParser = ({ columnIdIndex } = {}) => {
    const [data, setData] = (0, react_1.useState)([]);
    const [columnsOrder, setColumnsOrder] = (0, react_1.useState)([]);
    const [errors, setErrors] = (0, react_1.useState)([]);
    const parseFile = (0, react_1.useCallback)((file) => {
        if (!file) {
            return;
        }
        papaparse_1.default.parse(file, {
            header: true,
            skipEmptyLines: true,
            delimiter: ',',
            quoteChar: '"',
            complete: (results) => {
                var _a;
                const errors = [];
                const parsedData = [];
                const uniqueKeyFields = new Set();
                const systemErrors = results.errors.reduce((acc, { row, type }) => { var _a; return (Object.assign(Object.assign({}, acc), { [row]: [...(_a = acc[row]) !== null && _a !== void 0 ? _a : [], type] })); }, {});
                results.data.forEach((row, index) => {
                    var _a;
                    let rowErrors = [];
                    const newRow = {};
                    for (const [key, value] of Object.entries(row)) {
                        try {
                            newRow[key] = value.startsWith('[') || value.endsWith(']') ? JSON.parse(value) : value;
                        }
                        catch (e) {
                            rowErrors.push(ErrorTypes.ParseArray);
                        }
                    }
                    const emptyError = getEmptyError(row);
                    const duplicatedKeyFieldError = !(0, ramda_1.isNil)(columnIdIndex)
                        ? getKeyFieldError(row, columnIdIndex, uniqueKeyFields)
                        : null;
                    rowErrors = [...rowErrors, emptyError, duplicatedKeyFieldError, ...(_a = systemErrors[index]) !== null && _a !== void 0 ? _a : []].filter((error) => !!error);
                    if ((rowErrors.length === 1 && rowErrors[0] === ErrorTypes.FieldMismatch) || !rowErrors.length) {
                        parsedData.push(newRow);
                    }
                    else {
                        errors.push(rowErrors[0]);
                    }
                });
                const columnsOrder = (_a = results.meta.fields) !== null && _a !== void 0 ? _a : [];
                setData(parsedData);
                setColumnsOrder(columnsOrder);
                setErrors(errors);
            },
            error: () => {
                setErrors([ErrorTypes.Parse]);
                setData([]);
            },
        });
    }, [columnIdIndex]);
    const reset = (0, react_1.useCallback)(() => {
        setData([]);
        setErrors([]);
    }, []);
    return {
        data,
        columnsOrder,
        errors,
        parseFile,
        reset,
    };
};
exports.useCSVParser = useCSVParser;
